import moment from 'moment/moment';
import T from 'i18n-react';
import compact from 'lodash/compact';

export const makeZeroDate = () => new Date(0, 0, 0, 0, 0);

export const displayGroupedDates = (
  dates: Array<moment.MomentInput> = [],
): Array<string> => {
  // a group has sequential dates
  // e.g. [[8/19, 8/20, 8/21], [8/23], [8/27, 8/28]]
  const groups = [[]];
  let index = 0;
  dates
    .map((d) => moment(d))
    .sort((a, b) => a - b)
    .map((date, i, dates) => {
      // if dates are not sequential, next date is added to next group.
      if (i !== 0 && !dates[i - 1].clone().add(1, 'day').isSame(date, 'day')) {
        index += 1;
        groups.push([]);
      }
      groups[index].push(date);
    });

  // convert sequential dates to duration
  // e.g. [8/19, 8/20, 8/21] -> 8/19〜8/21
  const data = [];
  groups.map((group) => {
    if (2 < group.length) {
      data.push(
        group[0].format('M/D') +
          '〜' +
          moment(group[group.length - 1]).format('M/D'),
      );
    } else {
      group.map((date) => data.push(date.format('M/D')));
    }
  });
  return data;
};

export const getDaysInDuration = (
  startDate,
  endDate,
): Array<{ date: moment.Moment, text: string }> => {
  const dates = [];
  const format = T.translate('moment.date');

  let date = moment(startDate);
  while (moment(endDate).isSameOrAfter(date, 'day')) {
    dates.push({ date, text: date.format(format) });
    date = date.clone().add(1, 'day');
  }
  return dates;
};

export const getDateRangeText = (
  startDate: moment.Moment,
  endDate: moment.Moment | false | null,
  { delimiter = ' - ' } = {},
) =>
  compact([
    startDate.format(T.translate('moment.dayWithWeek')),
    !!endDate &&
      endDate.format(
        endDate.isSame(startDate, 'year')
          ? T.translate('moment.dayWithWeekWithoutYear')
          : T.translate('moment.dayWithWeek'),
      ),
  ]).join(delimiter);

export const createDataURLFromMediaUrl = (
  src: string | Array<string>,
  onLoaded: function,
  type = 'image/jpeg',
) => {
  const loadedImages = [];
  const srcList = typeof src === 'string' ? [src] : src;
  srcList.forEach((s) => {
    const image = new Image();
    image.src = s;
    image.crossOrigin = '';
    image.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      // Set width and height
      canvas.width = image.width;
      canvas.height = image.height;
      // Draw the image
      ctx.drawImage(image, 0, 0);

      loadedImages.push(canvas.toDataURL(type));
      if (loadedImages.length === srcList.length) {
        onLoaded(loadedImages);
      }
    };
  });
};

export const base64ToBlob = (base64, type = 'image/jpeg') => {
  const base64Data = base64.split(',')[1];
  const data = window.atob(base64Data);
  const buff = new ArrayBuffer(data.length);
  const arr = new Uint8Array(buff);
  let i, dataLen;
  for (i = 0, dataLen = data.length; i < dataLen; i++) {
    arr[i] = data.charCodeAt(i);
  }
  return new Blob([arr], { type });
};

export const remToPx = (rem: number): number =>
  rem * parseFloat(getComputedStyle(document.documentElement).fontSize);

export const getFullLocationPath = (location) => {
  const path = location.pathname;
  const searchParams = new URLSearchParams(location.search);
  const query = searchParams.toString();
  return query ? path + '?' + query : path;
};
